import { BillingInfo } from '../../../models/BillingInfo';

export const GET_BILLING_INFO = 'GET_BILLING_INFO';

export type GetBillingInfoAction = {
    type: typeof GET_BILLING_INFO;
    payload: {
        info: BillingInfo;
    };
};

export type BillingInfoActionTypes = GetBillingInfoAction;
